import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "data-disabled", "for"]

import {
		inject
	} from "vue"

	
	const __default__ = { name: 'VLabel' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	const fieldDisabled: boolean = inject('fieldDisabled', null) || inject('fieldsetDisabled', null) || false
	const controlId: string = inject('controlId', null) || ''
	const labelId: string = inject('labelId', null) || ''

	function clickHandler() {
		document.getElementById(controlId)?.click()
	}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    id: _unref(labelId) ?? undefined,
    "data-slot": "label",
    "data-disabled": _unref(fieldDisabled) ? true : null,
    for: _unref(controlId),
    class: "select-none text-base/6 text-zinc-950 data-[disabled]:opacity-50 sm:text-sm/6 dark:text-white",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (clickHandler()), ["prevent"]))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1))
}
}

})